import { render, staticRenderFns } from "./SeminarEntryBulkMessageTarget.vue?vue&type=template&id=b1cbfd9a"
import script from "./SeminarEntryBulkMessageTarget.vue?vue&type=script&lang=js"
export * from "./SeminarEntryBulkMessageTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports